<template>
  <div class="ui inline dropdown">
    <div
      class="ui vertical labeled menu transition visible"
      style="display: block !important"
      v-if="token"
    >
      <div class="ui top attached message">
        <i class="close icon" @click="emitClose"></i>
        <span v-html="renderMarkdown(description)"></span>
      </div>
      <template v-if="token.type === 'tail'">
        <template v-if="token.ref">
          <h4 class="ui header">{{ $t('TOKEN_REF_HEADER') }}</h4>
          <SingleTokenMenuFragment
            :token="token.ref"
            @token-update="emitTokenRefUpdate"
            v-if="token.ref"
            :app="app"
          />
          <h4 class="ui header">{{ $t('TOKEN_RELATION_HEADER') }}</h4>
          <TailRelationMenuFragment
            :relation="token.rel"
            @relation-update="emitTokenRelUpdate"
            @relation-remove="removeRelation"
            v-if="token.rel"
          />
        </template>

        <h4 class="ui header" v-if="token.ref">{{ $t('TOKEN_TARGET_HEADER') }}</h4>
        <SingleTokenMenuFragment
          :token="token.target"
          @token-update="emitTokenTargetUpdate"
          :resolved="resolved"
          :app="app"
          v-if="token.target"
        />

        <!-- includeInvisible (!onlyVisible) checkbox -->
        <div class="item">
          <div class="ui checkbox">
            <input
              type="checkbox"
              name="includeInvisible"
              v-model="includeInvisible"
              @change="emitIncludeInvisibleChange"
            />
            <label>{{ $t('TOKEN_INCLUDE_INVISIBLE') }}</label>
          </div>
        </div>

        <a class="item" @click.prevent.stop="addRelation()" v-if="!token.rel">
          <i class="arrows alternate icon" />
          {{ $t('TOKEN_RELATION_ADD') }}
        </a>
      </template>
      <WindowTokenMenuFragment
        :token="token"
        :resolved="resolved"
        @token-update="emitTokenUpdate"
        v-else-if="token.type === 'window'"
      />
      <SingleTokenMenuFragment
        :token="token"
        :resolved="resolved"
        @token-update="emitTokenUpdate"
        :app="app"
        v-else
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@charset "utf-8";

.scroller {
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
  text-overflow: ellipsis;
}

.menu {
  max-width: 300px;

  .message {
    max-width: 300px;
    white-space: normal !important;
    word-wrap: break-word;
    /* Ensure the message stays top of the menu when scrolling */
    /*
    position: sticky;
    top: 0px;
    z-index: 100;
    */
  }
}
</style>

<script>
// @flow

import marked from 'marked'
import SingleTokenMenuFragment from './SingleTokenMenuFragment'
import TailRelationMenuFragment from './TailRelationMenuFragment'
import WindowTokenMenuFragment from './WindowTokenMenuFragment'

const markedOptions = {
  smartypants: true,
  smartLists: true
}

export default {
  name: 'PathEditorMenu',
  props: ['token', 'resolved', 'description', 'app'],

  components: {
    SingleTokenMenuFragment,
    TailRelationMenuFragment,
    WindowTokenMenuFragment
  },

  data() {
    return {
      includeInvisible: !this.token?.onlyVisible ?? false
    }
  },

  methods: {
    emitTokenUpdate(t) {
      this.$emit('token-update', t)
    },

    emitClose() {
      this.$emit('close')
    },

    emitTokenTargetUpdate(t) {
      this.$emit('token-update', { ...this.token, target: t })
    },

    emitTokenRefUpdate(t) {
      this.$emit('token-update', { ...this.token, ref: t })
    },

    emitTokenRelUpdate(r) {
      this.$emit('token-update', { ...this.token, rel: r })
    },

    emitIncludeInvisibleChange() {
      this.$emit('token-update', { ...this.token, onlyVisible: !this.includeInvisible })
    },

    removeRelation() {
      this.$emit('token-update', { ...this.token, rel: null, ref: null })
    },

    addRelation() {
      this.$emit('token-update', { ...this.token, rel: 'nearest', ref: { type: 'wildcard' } })
    },

    renderMarkdown(md) {
      const options = { ...markedOptions }
      if (md) return marked(_.trim(md), options)
    }
  },

  watch: {
    token(t) {
      if (!t) this.emitClose()
      else this.includeInvisible = !t.onlyVisible
    }
  }
}
</script>
